import { connect } from 'react-redux';

import { IReduxState } from '../../types/redux';
import { Hero, IHeroProps } from '../../components/Hero';

type THeroStateProps = Pick<IHeroProps, 'title' | 'isDobroshriftEnabled'>;

export function mapStateToProps(state: IReduxState): THeroStateProps {
  return {
    title: state.mainpage.seoData.h1,
    isDobroshriftEnabled: state.features.isDobroshriftEnabled,
  };
}

export const HeroContainer = connect(mapStateToProps)(Hero);
